import React, { useState } from 'react';
import './AIChatFeed.css';
import AiChat from '../../../../../../../../../assets/ai_assistant.svg';
import chatLoadDot from '../../../../../../../../../assets/chat-load-dot.svg';
import Markdown from 'react-markdown'
import { useStore } from '../../../../../../../../../Hooks/useStore';

const AIChatFeed = ({ data, onSend, loading }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const buttons = ["How to perform CPR", "Difficulty Breathing", "Trauma", "Connect with Crew"];
  const { rootStore } = useStore();

  const DatePrettier = (dateStr) => {
    const date = new Date(dateStr);

    // Extract hours and minutes
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const amPm = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    hours = hours % 12 || 12; // Convert 0 to 12 for midnight and handle 12-hour format

    // Format minutes with leading zero if needed
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    const formattedTime = `${hours}:${formattedMinutes} ${amPm}`;
    return formattedTime;
  }


  let chatItems;
  if (loading && data.length > 0) {
    chatItems = data.map((chatGroup, index) => {
      return (
        <>
          <div key={index}>
            {
              index !== 0 &&
              (<div className='question-container'>
                <div className='chat-content-you'>
                  <p>{chatGroup.you}</p>
                </div>
                <div className='time'>{chatGroup.time ? DatePrettier(chatGroup?.time) : ""}</div>
              </div>)
            }
            <div className='answere-container'>
              <div className='profile-container'>
                <span className='profile'><img src={AiChat} alt='Ai chat icon' /></span>
                <span className='profile-txt'>ASH</span>
              </div>
              <div className='chat-content-ai'>
                <p><Markdown>{chatGroup.response}</Markdown></p>
              </div>
              <div className='time'>{chatGroup.time ? DatePrettier(chatGroup?.time) : ""}</div>
            </div>
          </div>
          {
            index == (data.length - 1) && <div className='answere-container' style={{ width: '20%' }}>
              <div className='profile-container'>
                <span className='profile'><img src={AiChat} alt='Ai chat icon' /></span>
                <span className='profile-txt'>Assistant</span>
              </div>
              <div className='chat-content-ai' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 12, gap: 0, width: 58 }}>
                <img src={chatLoadDot} alt='dot' style={{ height: 6, width: 6 }} />
                <img src={chatLoadDot} alt='dot' style={{ height: 6, width: 6, marginLeft: 8, marginRight: 8 }} />
                <img src={chatLoadDot} alt='dot' style={{ height: 6, width: 6 }} />
              </div>
            </div>
          }
        </>
      );
    });
  } else {
    if (data.length > 0) {
      chatItems = data.map((chatGroup, index) => {
        return (
          <div key={index}>
            {
              index !== 0 &&
              (<div className='question-container'>
                <div className='chat-content-you'>
                  <p>{chatGroup.you}</p>
                </div>
                <div className='time'>{chatGroup.time ? DatePrettier(chatGroup?.time) : ""}</div>
              </div>)
            }
            <div className='answere-container'>
              <div className='profile-container'>
                <span className='profile'><img src={AiChat} alt='Ai chat icon' /></span>
                <span className='profile-txt'>ASH</span>
              </div>
              <div className='chat-content-ai'>
                <p>
                <Markdown>{chatGroup.response}</Markdown>
                </p>
              </div>
              <div className='time'>{chatGroup.time ? DatePrettier(chatGroup?.time) : ""}</div>
            </div>
          </div>
        );
      });
    } else {

      chatItems = <div>
        <div key={1} style={{ width: "73%" }}>
          <div className='answere-container'>
            <div className='profile-container'>
              <span className='profile'><img src={AiChat} alt='Ai chat icon' /></span>
              <span className='profile-txt'>ASH</span>
            </div>
            <div className='chat-content-ai'>
              <p>Hello, I’m your AI assistant. How can I assist you today?</p>
            </div>
            <div className='time'>{DatePrettier(new Date())}</div>
          </div>
        </div>
        <div className='click-prompt-btn'>
          {
            buttons.map((btn, index) => {
              return (
                <button onClick={() => { 
                  onPromptClick(btn); 
                  setActiveIndex(index);
                  rootStore.assistantStore.setPrompt(" ");
                }} className={activeIndex === index ? 'active-quick-chat-button' : null} key={index}>{btn}</button>
              );
            })
          }
        </div>
      </div>
    }
  }

  const onPromptClick = (btnTitle) => {
    if (btnTitle == "How to perform CPR") {
      onSend("We have a patient in need of CPR. What are the steps we should follow?");
    } else if (btnTitle == "Difficulty Breathing") {
      onSend("We have a patient experiencing difficulty breathing. What should we do?");
    } else if (btnTitle == "Trauma") {
      onSend("We have a patient with a trauma injury. What immediate actions should we take?");
    } else if (btnTitle == "Connect with Crew") {
      onSend("We need to connect with the crew for assistance. How should we proceed?");
    } else {

    }
  }

  return (
    <div>
      {chatItems}
    </div>
  );
}

export default AIChatFeed;
